module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1Jw8y"))).then(() => parcelRequire('3a9aZ'));